import React, { useState, useRef, useEffect } from "react";
import { PrismicRichText } from "@prismicio/react";
import styled from "styled-components";

const ProjectTeamContainer = styled.div`
  margin-top: 1em;
`;

const TeamButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: left;

  width: 100%;

  &:hover {
    opacity: 0.8;
  }
`;

const TeamContent = styled.div`
  max-height: ${(props) => (props.isOpen ? props.contentHeight + "px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease-out;
`;

const TeamMember = styled.div`
  margin-bottom: 1em;

  & h2 {
    font-weight: bolder;
  }
`;

const ProjectTeam = ({ projectTeam }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  // Measure the content height when it changes
  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [projectTeam]);

  if (!projectTeam || projectTeam.length === 0) {
    return null;
  }

  return (
    <ProjectTeamContainer>
      <TeamButton onClick={() => setIsOpen(!isOpen)}>
        <span>Project Team</span>
        <span>{isOpen ? "–" : "+"}</span>
      </TeamButton>

      <TeamContent isOpen={isOpen} contentHeight={contentHeight}>
        <div ref={contentRef}>
          {projectTeam.map((item, index) => (
            <TeamMember key={`team_member_${index}`}>
              <h2>{item.section_title_field.text}</h2>
              <PrismicRichText field={item.section_text_field.richText} />
            </TeamMember>
          ))}
        </div>
      </TeamContent>
    </ProjectTeamContainer>
  );
};

export default ProjectTeam;
